import { useEffect } from 'react';
import { engine } from '../hooks/useEngine.ts';
import { HeartIcon } from './Icons.tsx';

/** Celebration shown when both people tapped the heart. */
export function SparkOverlay({ peerName }: { peerName: string }) {
  useEffect(() => {
    const id = window.setTimeout(() => engine.dismissSpark(), 4200);
    return () => window.clearTimeout(id);
  }, []);

  return (
    <div className="absolute inset-0 z-40 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative flex flex-col items-center px-8 text-center">
        <span className="absolute -inset-16 -z-10 rounded-full bg-phidio-500/30 blur-3xl" aria-hidden />

        <span className="relative flex h-28 w-28 items-center justify-center rounded-full bg-gradient-to-br from-phidio-400 to-phidio-700 text-white shadow-[0_0_80px_-10px_var(--color-phidio-500)]">
          <span className="absolute inset-0 rounded-full bg-phidio-500/60 animate-pulse-ring" />
          <HeartIcon filled width={52} height={52} />
        </span>

        <h2 className="mt-7 text-4xl font-light tracking-tight">
          It's a <span className="font-semibold text-phidio-400">spark</span>
        </h2>
        <p className="mt-2 max-w-xs text-white/60">
          You and {peerName} both felt it. Saved to your sparks — you can find each other again for
          the next 12 hours, even after this call ends.
        </p>

        <button
          type="button"
          onClick={() => engine.dismissSpark()}
          className="mt-7 rounded-full bg-white/10 px-6 py-2.5 text-sm font-semibold transition hover:bg-white/20"
        >
          Keep talking
        </button>
      </div>
    </div>
  );
}
